export const theme = {
  colors: {
    background: '#141414',
    surface: '#181818',
    surfaceElevated: '#222222',
    primary: '#e50914',
    primaryHover: '#f40612',
    text: '#ffffff',
    textMuted: '#b3b3b3',
    border: '#333333',
  },
  layout: {
    maxWidth: '1200px',
    navbarHeight: '68px',
    borderRadius: '4px',
  },
  typography: {
    fontFamily: "'Roboto', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    baseFontSize: '16px',
  },
  shadows: {
    card: '0 8px 24px rgba(0, 0, 0, 0.6)',
    modal: '0 16px 48px rgba(0, 0, 0, 0.85)',
  },
  transitions: {
    fast: '150ms ease-out',
    normal: '250ms ease-out',
    slow: '400ms ease-out',
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  },
};
